// Vue & Plugins
import { acceptHMRUpdate, defineStore } from 'pinia'
import { ref, watch } from 'vue'

// Models
import { DEFAULT_PER_PAGE } from '../common/models/pagination'
import {
  NotificationReadFilter,
  NotificationTypeGroup,
} from './models/notification'

export const useNotificationFilterStore = defineStore(
  'NotificationFilterStore',
  () => {
    const perPage = ref(DEFAULT_PER_PAGE)
    const page = ref(1)

    // Matches the API default so the list opens on what still needs attention
    const filter = ref<NotificationReadFilter>('unread')
    const typeGroup = ref<NotificationTypeGroup>('all')

    // A new filter starts from the first page, otherwise a narrower result set can leave the user on an empty page
    watch([filter, typeGroup], () => {
      page.value = 1
    })

    return {
      perPage,
      page,
      filter,
      typeGroup,
    }
  },
)

if (import.meta.hot !== null && import.meta.hot !== undefined) {
  import.meta.hot.accept(
    acceptHMRUpdate(useNotificationFilterStore, import.meta.hot),
  )
}
